import Page from 'components/Page'
import { View } from 'components/View'
import React from 'react'
import useIntl from 'modules/component/utils/hooks/useIntl'
import getTitleExerciseUtil from 'pages/Exercise/components/Wrapper/utils/get-title/index.js'
import { getDescriptionExerciseUtil } from 'pages/Exercise/components/Wrapper/utils/getDescription/index.js'

/**
 * @param props
 * @param props.children
 * @param props.exerciseName
 * @param props.url
 * @param props.musclesWorkedStr
 * @param props.id
 * @param props.isBodyweight
 * @return {Element}
 * @constructor
 */
const ExerciseWrapper = (props) => {
  const {
    children,
    exerciseName,
    isBodyweight,
    url
  } = props

  const intl = useIntl()
  const title = getTitleExerciseUtil({
    intl,
    exerciseName
  })

  const description = getDescriptionExerciseUtil({
    intl,
    exerciseName,
    isBodyweight
  })

  if (!exerciseName) {
    return <></>
  }

  return (
    <Page
      title={title}
      description={description}
      url={url}
    >
      <View
        bgc='white'
      >
        <View style={{ overflow: 'scroll' }}>
          {children}
        </View>
      </View>
    </Page>
  )
}

export default ExerciseWrapper
